var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 607,
    height: 667,
    viewBox: "0 0 607 667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M566.602 305.809C544.362 386.846 460.263 434.613 378.761 412.5C317.499 314.746 249.217 306.767 271.457 225.73C293.697 144.693 377.797 96.9263 459.299 119.039C540.801 141.153 588.842 224.772 566.602 305.809Z",
    fill: "#21975D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M335.768 378.642C359.07 459.379 295.745 540.44 228.268 559.296C132.64 529.676 76.6893 546.688 42.1929 464.298C18.8904 383.56 65.7189 298.935 146.787 275.281C227.856 251.628 312.465 297.904 335.768 378.642Z",
    fill: "#21975D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_587_225)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.87 232.929L155.093 232.929C154.235 232.929 153.539 232.209 153.539 231.32L153.539 153.789C153.539 152.9 154.235 152.18 155.093 152.18L155.87 152.18L155.87 232.929Z",
    fill: "#121515"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M467.481 243.798H468.259C469.117 243.798 469.813 244.518 469.813 245.406L469.813 291.104C469.813 291.993 469.117 292.713 468.259 292.713H467.481L467.481 243.798Z",
    fill: "#121515"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M467.481 172.367H468.259C469.117 172.367 469.813 173.087 469.813 173.976L469.813 205.698C469.813 206.586 469.117 207.306 468.259 207.306H467.481L467.481 172.367Z",
    fill: "#121515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.87 65.6857C155.87 38.3186 155.87 24.6351 162.845 15.0426C165.098 11.9446 167.825 9.22019 170.925 6.96937C180.526 0 194.221 0 221.612 0H401.74C429.13 0 442.826 0 452.426 6.96937C455.527 9.22019 458.254 11.9446 460.506 15.0426C467.482 24.6351 467.482 38.3186 467.482 65.6858V600.489C467.482 627.856 467.482 641.54 460.506 651.132C458.254 654.23 455.527 656.955 452.426 659.205C442.826 666.175 429.13 666.175 401.74 666.175H221.612C194.221 666.175 180.526 666.175 170.925 659.205C167.825 656.955 165.098 654.23 162.845 651.132C155.87 641.54 155.87 627.856 155.87 600.489V65.6857Z",
    fill: "#3A4245"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.756 67.8602C159.756 42.8222 159.756 30.3031 166.137 21.527C168.199 18.6927 170.693 16.2001 173.53 14.1409C182.313 7.76465 194.843 7.76465 219.902 7.76465H403.45C428.509 7.76465 441.039 7.76465 449.822 14.1409C452.659 16.2001 455.154 18.6927 457.215 21.527C463.596 30.3031 463.596 42.8221 463.596 67.8601V598.315C463.596 623.353 463.596 635.872 457.215 644.649C455.154 647.483 452.659 649.975 449.822 652.035C441.039 658.411 428.509 658.411 403.45 658.411H219.902C194.843 658.411 182.313 658.411 173.53 652.035C170.693 649.975 168.199 647.483 166.137 644.649C159.756 635.872 159.756 623.353 159.756 598.315V67.8602Z",
    fill: "#121515"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_587_225",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 12,
    width: 295,
    height: 638
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M164.418 62.7353C164.418 41.7733 164.418 31.2923 169.761 23.9448C171.486 21.5719 173.575 19.4851 175.95 17.7611C183.303 12.4229 193.793 12.4229 214.773 12.4229H408.578C429.558 12.4229 440.048 12.4229 447.402 17.7611C449.777 19.4851 451.865 21.5719 453.591 23.9448C458.934 31.2923 458.934 41.7733 458.934 62.7354V598.781C458.934 619.743 458.934 630.224 453.591 637.571C451.865 639.944 449.777 642.031 447.402 643.755C440.048 649.093 429.558 649.093 408.578 649.093H214.773C193.793 649.093 183.303 649.093 175.95 643.755C173.575 642.031 171.486 639.944 169.761 637.571C164.418 630.224 164.418 619.743 164.418 598.781V62.7353Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_587_225)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.418,
    y: 12.4229,
    width: 294.516,
    height: 636.671,
    fill: "url(#pattern0_587_225)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.418,
    y: 12.4229,
    width: 294.516,
    height: 636.671,
    fill: "url(#pattern1_587_225)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_587_225",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_587_225",
    transform: "matrix(0.000934553 0 0 0.000437627 -0.00201651 0.0382492)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_587_225",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_587_225",
    transform: "matrix(0.00168887 0 0 0.00078125 -0.011728 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_587_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 316.274,
    height: 666.175,
    fill: "white",
    transform: "translate(153.539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile1);
export default __webpack_public_path__ + "static/media/mobile-1.2a6385201e9bb1f574b5a6030d336292.svg";
export { ForwardRef as ReactComponent };